module.exports = __webpack_public_path__ + "img/whrmhole.34817701.svg";